import React from "react";
import { Box, Flex } from "rebass";
import styled from "styled-components";
import theme from "../../../../../../../theme/themeThree";
import { Headline, Subheader } from "../../../../../../Components/Text";
import { getCardTitle } from "../../../../../../Utilities/Studio";
import loading from "../../../../../../../animations/empty.json";
import Lottie from "lottie-react";
import { TagRow } from "../../../../../../Components/CreatorCard/Components/TagRow";
import { ReactComponent as Mythic } from "../../../../../../Assets/Tiers/Badges/mythic.svg";
import { ReactComponent as Legendary } from "../../../../../../Assets/Tiers/Badges/legendary.svg";
import { ReactComponent as Rare } from "../../../../../../Assets/Tiers/Badges/rare.svg";
import { ReactComponent as Premium } from "../../../../../../Assets/Tiers/Badges/premium.svg";
import { ReactComponent as Standard } from "../../../../../../Assets/Tiers/Badges/standard.svg";
import { useTranslation } from "react-i18next";

/*  Our LOCAL component imports */
// import { ReactComponent as Pro } from "../../../../../../../assets/images/badges/pro-badge.svg";
// import { ReactComponent as Exclusive } from "../../../../../../../assets/images/badges/exclusive-badge.svg";
// import { ReactComponent as Top } from "../../../../../../../assets/images/badges/top-badge.svg";
import { AddCard } from "../../../../../../Components/CreatorCard/Components/AddCard";
import { StyledHeadline } from "../../../../styledComponents";

const lottieStyle = {
  height: 200,
  width: 200,
};

export const CardsList = ({
  onQuery,
  handleToggle,
  handleCardClick,
  userActivated,
  isRemix,
}: any) => {
  const { t } = useTranslation(`translation`, {
    keyPrefix: "studio",
  });
  if (!userActivated.length) {
    return (
      <>
        <Empty
          color="#36567f"
          border={`2px solid ${theme.colors.turbo}`}
          mb={1}
        ></Empty>
        <Empty color="#4e7868" border="2px solid #9ff4c1"></Empty>
        <StyledEmpty
          my={3}
          justifyContent="flex-start"
          flexDirection="column"
          alignItems="flex-start"
        >
          <Lottie animationData={loading} style={lottieStyle} loop={true} />
        </StyledEmpty>

        <StyledNoCardAmongUs
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          isRemix={isRemix}
        >
          <Headline mb={3}>{t(`noCardsHeader`)}</Headline>
          <Subheader color="chalk">{t(`noCardsBody`)}</Subheader>
        </StyledNoCardAmongUs>
      </>
    );
  }

  return (
    <>
      <StyledList isRemix={isRemix}>
        {" "}
        {userActivated.map((card: any) => {
          return (
            <EnabledCard
              key={card._id}
              card={card}
              onQuery={onQuery}
              handleCardClick={handleCardClick}
              handleToggle={handleToggle}
            />
          );
        })}
      </StyledList>
    </>
  );
};

const Empty = ({ color, border, mb }: any) => {
  return (
    <StyledEmpty
      justifyContent="center"
      flexDirection="column"
      alignItems="flex-start"
      mb={mb}
    >
      <StyledEmptyHeader mb={3} />
      <StyledEmptyTag color={color} border={border} />
    </StyledEmpty>
  );
};

const EnabledCard = ({
  card,
  onQuery,
  handleCardClick,
  handleToggle,
}: any) => {
  // const badges = getBadges(card.ui.badge, card.scopeUse);

  const TIER_BADGE_MAP: any = {
    500: <StyledMythic />,
    400: <StyledLegendary />,
    300: <StyledRare />,
    200: <StyledPremium />,
    100: <StyledStandard />,
  };

  // function getBadges(uiBadge: any, scopeUse: any) {
  //   let badges = [];
  //   if (uiBadge === "pro" || needsPro(scopeUse)) {
  //     badges.push(<Badge index={badges.length} key={badges.length} />);
  //   }
  //   if (scopeUse.includes("OG")) {
  //     badges.push(<ExclusiveBadge index={badges.length} mr={10} />);
  //   }
  //   if (uiBadge === "top") {
  //     badges.push(<TopBadge index={badges.length} mr={10} />);
  //   }

  //   return badges;
  // }

  return (
    <>
      <StyledDescription
        flexDirection="column"
        justifyContent="space-between"
        mb={3}
        rarity={card.ui.rarity}
        onClick={() => {
          handleCardClick(card);
        }}
      >
        <Flex justifyContent="space-between">
          <Flex
            flexDirection="row"
            justifyContent="flex-start"
            mb={3}
            alignItems={"center"}
          >
            <AddCard card={card} handleToggle={handleToggle} size={20} />
            <StyledHeadline ml={3}>{getCardTitle(card)}</StyledHeadline>
          </Flex>
          {TIER_BADGE_MAP[card.ui.rarity]}
        </Flex>
        <Flex flexDirection="row">
          <TagRow card={card} onQuery={onQuery} />
        </Flex>
      </StyledDescription>
    </>
  );
};

const StyledNoCardAmongUs = styled(Flex)<any>`
  padding-top: ${({ isRemix }) => {
    return isRemix ? "97" : "115";
  }}px;
`;

const StyledList = styled(Box)<any>`
  padding-bottom: ${({ isRemix }) => {
    return isRemix ? "90" : "0";
  }}px;
`;

const getboxShadowColor = (rarity: any) => {
  if (rarity === 500) {
    return `#3D444F 0 1px 4px, #3D444F 0 2px 10px, #3D444F 0 10px 20px,
  #3D444F 0 18px 40px, 5px 5px 15px 5px rgba(0, 0, 0, 0);`;
  }

  //legendary, todo
  if (rarity === 400) {
    return `#2E3749 0 1px 4px, #2E3749 0 2px 10px, #2E3749 0 10px 20px,
  #2E3749 0 18px 40px, 5px 5px 15px 5px rgba(0, 0, 0, 0);`;
  }

  //rare, todo
  if (rarity === 300) {
    return `#383342 0 1px 4px, #383342 0 2px 10px, #383342 0 10px 20px,
  #383342 0 18px 40px, 5px 5px 15px 5px rgba(0, 0, 0, 0);`;
  }

  //premium, todo
  if (rarity === 200) {
    return `#283940 0 1px 4px, #283940 0 2px 10px, #283940 0 10px 20px,
  #283940 0 18px 40px, 5px 5px 15px 5px rgba(0, 0, 0, 0);`;
  }

  //standard, todo
  if (rarity === 100) {
    return `#0f1519 0 1px 4px, #0f1519 0 2px 10px, #1b242c 0 10px 20px,
  #161f25 0 18px 40px, 5px 5px 15px 5px rgba(0, 0, 0, 0);`;
  }

  return `#0f1519 0 1px 4px, #0f1519 0 2px 10px, #1b242c 0 10px 20px,
  #161f25 0 18px 40px, 5px 5px 15px 5px rgba(0, 0, 0, 0);`;
};

const StyledDescription: any = styled(Box)`
  position: relative;
  background: ${theme.colors.darkerNed};
  border-radius: 10px 10px 10px 10px;
  padding: 15px;
  border: 2px solid
    ${(props: any) => {
      //@Chris, changes border colors
      if (props.rarity === 500) {
        return props.theme.colors.mythicAlpha40;
      }

      //legendary, todo
      if (props.rarity === 400) {
        return props.theme.colors.legendaryAlpha40;
      }

      //rare, todo
      if (props.rarity === 300) {
        return props.theme.colors.rareAlpha40;
      }

      //premium, todo
      if (props.rarity === 200) {
        return props.theme.colors.premiumAlpha40;
      }

      //standard, todo
      if (props.rarity === 100) {
        return props.theme.colors.darkerNavy;
      }

      return `rgba(0,0,0,0);`;
    }};
  &:hover {
    cursor: pointer;
    -webkit-box-shadow: ${(props: any) => {
      return getboxShadowColor(props.rarity);
    }};
    box-shadow: ${(props: any) => {
      return getboxShadowColor(props.rarity);
    }}
    background: ${theme.colors.midnightAlpha50};
    border: 2px solid
    ${(props: any) => {
      //@Chris, changes border colors
      if (props.rarity === 500) {
        return props.theme.colors.mythicAlpha80;
      }

      //legendary, todo
      if (props.rarity === 400) {
        return props.theme.colors.legendaryAlpha80;
      }

      //rare, todo
      if (props.rarity === 300) {
        return props.theme.colors.rareAlpha80;
      }

      //premium, todo
      if (props.rarity === 200) {
        return props.theme.colors.premiumAlpha80;
      }

      //standard, todo
      if (props.rarity === 100) {
        return props.theme.colors.nedLight;
      }

      return `rgba(0,0,0,0);`;
    }};
  }
`;

const StyledMythic = styled(Mythic)`
  height: 28px;
  width: 28px;
  padding-top: 1px;
`;

const StyledLegendary = styled(Legendary)`
  height: 26px;
  width: 26px;
  padding-top: 1px;
`;

const StyledRare = styled(Rare)`
  height: 28px;
  width: 28px;
  padding-top: 1px;
`;

const StyledPremium = styled(Premium)`
  height: 28px;
  width: 28px;
  padding-top: 1px;
`;

const StyledStandard = styled(Standard)`
  height: 28px;
  width: 28px;
  padding-top: 1px;
`;

const StyledEmpty = styled(Flex)`
  border-radius: 10px;
  justify-content: center;
  background: ${theme.colors.darkerNed};
  align-items: center;
  width: 100%;
  height: 100px;
  padding: 15px;
  &:hover {
    cursor: pointer;
  }
`;

const StyledEmptyHeader = styled(Flex)`
  border-radius: 10px;
  background: ${theme.colors.nedLight};
  align-items: center;
  width: 60%;
  height: 25px;
  padding: 15px;
  &:hover {
    cursor: pointer;
  }
`;

const StyledEmptyTag = styled(Flex)<any>`
  border-radius: 999px;
  background: ${(props: any) => {
    return props.color;
  }};
  align-items: center;
  border: ${(props: any) => {
    return props.border;
  }};
  width: 20%;
  height: 5px;
  padding: 8px;
  &:hover {
    cursor: pointer;
  }
`;
